import { render, staticRenderFns } from "./addVolunteerPlan.vue?vue&type=template&id=01aa51a4&scoped=true"
import script from "./addVolunteerPlan.vue?vue&type=script&lang=js"
export * from "./addVolunteerPlan.vue?vue&type=script&lang=js"
import style0 from "./addVolunteerPlan.vue?vue&type=style&index=0&id=01aa51a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa51a4",
  null
  
)

export default component.exports